import React, { FC } from 'react'
import { $confirmDialog } from '../dialog/confirmDialog';
import { SuccessToast } from '../ToastComponent/SuccessToast';
import { useTranslation } from 'react-i18next';
import { LogoutUser } from '../../utils/helper';
import { CLEARUSER } from '../../redux/features/userData';
import { CLEARCART } from '../../redux/features/CartData';
import { CLEARCHECKOUTADDRESS } from '../../redux/features/CheckoutAddress';
import { CLEARALLORDER } from '../../redux/features/AllOrder';
import { CLEAR_All_SAVED_CARD } from '../../redux/features/store';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

interface DeleteAccountProps{
    refrence:string
}

const DeleteAccount:FC<DeleteAccountProps> = ({refrence}) => {
    const isMobile=refrence=='mobile'
    const { t } = useTranslation();
      const dispatch = useDispatch();
      const navigation = useNavigate();
    const handleAccountDelete = async () => {
        let res = await $confirmDialog(
            t("are_you_sure_delete_account"),
            "",
            t("Home.no"),
            t("Home.yes")
        );
        if (!res) return;
         LogoutUser();
            dispatch(CLEARUSER());
            dispatch(CLEARCART());
            // CLEARCHECKOUTADDRESS
            dispatch(CLEARCHECKOUTADDRESS());
            // CLEARALLORDER
            dispatch(CLEARALLORDER());
            // CLEAR_All_SAVED_CARD
            dispatch(CLEAR_All_SAVED_CARD());
        
            sessionStorage.clear();
            localStorage.clear();
            navigation("/");
        SuccessToast(t("account_delete_success"));
    };  
    return (
        <>
            <div
                // className={`text-center rounded-[0.313rem] text-white bg-[#F00] m-4 px-6 py-3 text-lg font-bold cursor-pointer `}
            
                className={` cursor-pointer ${isMobile? 'text-center text-[#F00]  p-6 text-base font-semibold ':'text-center rounded-[0.313rem] text-white bg-[#F00] m-4 px-6 py-3 text-lg font-bold'}`}
                onClick={handleAccountDelete}
            >
                {t("delete_account")}
            </div>
        </>
    )
}

export default DeleteAccount